import type { Guide } from '../types';

/**
 * S-24.10-13 — osobne kolumny „Stawka” i „Typ pojazdu” w banku zleceń (odpowiedź z 21.10.2026 na pytanie 20;
 * scenariusz e2e 28). Lista zleceń w układzie z makiety FTL, dowolne zlecenia DEMO ze stawką i typem.
 */
export const guide: Guide = {
  flagKey: 'bankRateTypeColumns',
  title: 'Bank zleceń: osobne kolumny „Stawka” i „Typ pojazdu”',
  whatItDoes:
    'Na liście zleceń stawka zlecenia i wymagany typ pojazdu stoją we własnych kolumnach, a nie w drugiej linii pod kontrahentem i relacją. „Stawka” to kwota z walutą — po kliknięciu nagłówka lista układa się po kwocie. „Typ pojazdu” to typ z TMS, a pod nim wymagania: wózek, ADR, fix. Eksport do pliku ma te same kolumny.',
  audience: ['planista FTL', 'Team Leader (planista główny)', 'trader', 'administrator'],
  presentationItems: ['S-24.10-13'],
  steps: [
    {
      route: '/user-offers',
      routeFilter: { forklift: 'hide' },
      target: 'vehicle-type',
      title: 'Kolumna „Typ pojazdu”',
      description:
        'Wymagany typ pojazdu z TMS (np. JUMBO, MEGA, K 13,2 LDM), a pod nim wymagania zlecenia: wózek, ADR, fix. Pod relacją zostaje tylko liczba punktów trasy.',
      action: 'Otwórz „Zlecenia” i spójrz na kolumnę „Typ pojazdu” obok „TMS”.',
      recorder: { account: 'ftl' },
    },
    {
      route: '/user-offers',
      routeFilter: { forklift: 'hide' },
      target: 'rate-column',
      title: 'Kolumna „Stawka”',
      description:
        'Stawka zlecenia z TMS: kwota, a pod nią waluta. Zlecenie bez stawki ma kreskę. Kliknięcie nagłówka „Stawka” układa listę po kwocie.',
      action: 'Kliknij nagłówek „Stawka”, żeby ułożyć listę po kwocie.',
      recorder: { account: 'ftl' },
    },
  ],
};
